import { ChiptaElement, html, css } from 'chipta-libs/main.js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { markdown } from 'chipta-libs/libs/drawdown.js';


class MarkDown extends ChiptaElement {

  static get properties() {
    return {
      text: {type: String},
    }
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    if (attr === 'text') {
      this.text = newValue;
    }
  }

  render() {
    return unsafeHTML(markdown(this.text));
  }

  static get styles() {
    return css`
      :host {
        display: block;
      }
    `;
  }

}

customElements.define('mark-down', MarkDown);
